/* Estrani - laadt de tweede productfoto alvast, zodat de kaart niet flikkert
   op het moment dat je erover gaat. Door Claude gebouwd, veilig te verwijderen. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  /* De tweede foto is de foto die bij hover in beeld schuift. */
  function warm(img, priority) {
    if (!img) return;
    if (img.complete && img.naturalWidth) return;
    img.setAttribute('fetchpriority', priority);
    img.setAttribute('loading', 'eager');
  }

  function promote(card, urgent) {
    var imgs = card.querySelectorAll('img');
    if (imgs.length < 2) return;
    warm(imgs[1], urgent ? 'high' : 'low');
    if (urgent && imgs.length > 2) warm(imgs[2], 'low');
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      promote(entry.target, false);
    });
  }, { rootMargin: '600px 0px' });

  function scan() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.__aiPreload) return;
      card.__aiPreload = true;
      io.observe(card);
    });
  }

  var pending = false;
  function scanSoon() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }

  function boot() {
    scan();
    new MutationObserver(scanSoon).observe(document.body, { childList: true, subtree: true });
    /* Gaat de muis er toch eerder over, haal hem dan met voorrang op. */
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      var card = t && t.closest ? t.closest('product-card') : null;
      if (card) promote(card, true);
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', scan);
})();
